export * from "-!../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js??ref--5-1!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/src/index.js??ref--5-2!../../node_modules/less-loader/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=6ec993ba&lang=less&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/render/index.vue?vue&type=style&index=0&id=6ec993ba&lang=less&scoped=true&
// module id = 10
// module chunks = 1